import { CustomerVehicleShortInfo } from "@tm/models"
import { ajaxAuth } from "@tm/utils"
import { getVehicleGsiServiceUrl } from "./helper"

export async function showCustomerVehicles(customerId: string): Promise<CustomerVehicleShortInfo[]> {
    const response = await ajaxAuth<{ vehicles?: CustomerVehicleShortInfo[] }>(
        {
            url: `${getVehicleGsiServiceUrl()}/ShowCustomerVehicles`,
            body: { customerId },
        },
        undefined,
        undefined,
        true
    )

    return response?.vehicles ?? []
}
